const paymentTypes = {
  EXISTING: 'existing',
  NEW: 'new',
  ACH: 'ach',
};

export default paymentTypes;
